/**
 * Moved to `shared/src/review/supporting-pages-render-gate.ts` so the review surface and the server-side
 * export read one copy of this logic. Edit it there.
 *
 * Named rather than `export *`: the Vite dev server's CommonJS interop runs a
 * star re-export before the module it re-exports has loaded.
 */
export {
  supportingPagesColumnsReady,
  supportingPagesEmptyReady,
  supportingPagesSettling
} from '@taptimize/shared/dist/review/supporting-pages-render-gate';
export type {
  SupportingPagesGateState,
  SupportingPagesLoadStatus
} from '@taptimize/shared/dist/review/supporting-pages-render-gate';
